import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent {
  @Input() isLoading = false;
  @Input() full = false;
  @Input() general = false;

  constructor(private loadingService: LoadingService) {}
}
